import { Box, useTheme } from '@mui/material';
import { Formik, Form } from 'formik';
import { FormHeader } from './FormHeader';
import { FormContent } from './FormContent';
import { FormActions } from './FormActions';
import { initialValues } from '../../constants/petConstants';
import { petValidationSchema } from '../../validations/petValidationSchema';
import { usePet } from '../../context/usePet';

interface FormContainerProps {
  mode: 'create' | 'edit';
  initialData?: any;
}

export function FormContainer({ mode, initialData }: FormContainerProps) {
  const theme = useTheme();
  const { createPet, updatePet, isSubmitting, petData } = usePet();
  
  console.log('FormContainer - mode:', mode, 'petData:', petData);
  
  const handleSubmit = async (values: any) => {
    try {
      if (mode === 'create') {
        await createPet(values);
      } else {
        if (petData?.attributeId && typeof petData.attributeId === 'string') {
          await updatePet(petData.attributeId, values);
        } else {
          console.error('Pet data não encontrada ou attributeId inválido:', petData);
          throw new Error('Dados do pet não encontrados');
        }
      }
    } catch (error) {
      console.error('Erro ao salvar pet:', error);
      throw error;
    }
  };

  const formInitialValues = mode === 'edit' && petData ? {
    nome: petData.nome || '',
    tipo: petData.tipo || '',
    raca: petData.raca || '',
    idade: petData.idade || 0,
    peso: petData.peso || 0,
    cor: petData.cor || '',
    observacoes: petData.observacoes || '',
    foto: undefined,
  } : initialValues;

  return (
    <Box style={{ 
      background: theme.palette.background.paper, 
      borderRadius: 16, 
      padding: 32, 
      boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)', 
      maxWidth: '100%', 
      margin: '0 auto' 
    }}>
      <Formik
        initialValues={formInitialValues}
        validationSchema={petValidationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, errors, touched, setFieldValue }) => (
          <Form>
            <FormHeader mode={mode} />
            <FormContent
              values={values}
              errors={errors}
              touched={touched}
              isSubmitting={isSubmitting}
              mode={mode}
              isAdmin={false}
              authUser={null}
              setFieldValue={setFieldValue}
            />
            <FormActions isSubmitting={isSubmitting} mode={mode} />
          </Form>
        )}
      </Formik>
    </Box>
  );
} 